import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface LoginState {
  email: string;
  password: string;
  error: string;
}

const initialState: LoginState = {
  email: '',
  password: '',
  error: '',
};

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    updateLoginField(state, action: PayloadAction<{ field: keyof LoginState; value: string }>) {
      const { field, value } = action.payload;
      state[field] = value;
    },
    setLoginError(state, action: PayloadAction<string>) {
      state.error = action.payload;
    },
    clearLoginForm() {
      return initialState;
    },
  },
});

export const { updateLoginField, setLoginError, clearLoginForm } = loginSlice.actions;
export default loginSlice.reducer;
